exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._3oxgJi_udZj22oeDqvI5sN{background:#f3f5f7;border-bottom:.07143rem solid #ccc;padding:0}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"StudentSelect": "_3oxgJi_udZj22oeDqvI5sN"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/build-omni-operation-ui_develop/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Group/SessionReport/StudentSelect/style.postcss
// module id = 1849
// module chunks = 0